// Module
var code = `<section class="video-share-help-wrapper" role="status" aria-live><p translate="activity-editor-new_video-share-help"></p></section>`;
// Exports
export default code;